import { useState, useEffect, createContext, useContext } from 'react'

interface User {
  email: string
  name: string
}

interface AuthContextType {
  user: User | null
  isAuthenticated: boolean
  signIn: (email: string, password: string) => Promise<boolean>
  signOut: () => void
}

const STORAGE_KEY = 'provenance_one_auth'

// Mock user database
const MOCK_USERS = {
  'demo@provenanceone.ai': {
    password: 'password',
    name: 'Demo User',
  },
}

export function useAuth() {
  const [user, setUser] = useState<User | null>(() => {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : null
  })

  useEffect(() => {
    if (user) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(user))
    } else {
      localStorage.removeItem(STORAGE_KEY)
    }
  }, [user])

  const signIn = async (email: string, password: string): Promise<boolean> => {
    // Mock authentication
    const mockUser = MOCK_USERS[email as keyof typeof MOCK_USERS]

    if (mockUser && mockUser.password === password) {
      setUser({
        email,
        name: mockUser.name,
      })
      return true
    }

    return false
  }

  const signOut = () => {
    setUser(null)
  }

  return {
    user,
    isAuthenticated: !!user,
    signIn,
    signOut,
  }
}
